import { render, staticRenderFns } from "./AmbassadorSummary.vue?vue&type=template&id=3899b2ae&"
import script from "./AmbassadorSummary.vue?vue&type=script&lang=js&"
export * from "./AmbassadorSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports